import { render, staticRenderFns } from "./RecognitionBySupplier.vue?vue&type=template&id=5d177e8e&scoped=true&"
import script from "./RecognitionBySupplier.vue?vue&type=script&lang=ts&"
export * from "./RecognitionBySupplier.vue?vue&type=script&lang=ts&"
import style0 from "./RecognitionBySupplier.vue?vue&type=style&index=0&id=5d177e8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d177e8e",
  null
  
)

export default component.exports